<template>
  <div class="additional-pages">
    <nav class="sub-menu">
      <span class="button-wrapper" @click="handleAddPage"><a class="button is-info">+</a>Страница</span>
      <ul class="centered">
        <li v-for="item in pages" @click="getPage(item.id)">
          <router-link :to="{ name: 'AdditionalPage', params: { id: item.id } }"
          active-class="is-active" :key="item.id"
          :class="!$route.params.id && item.id === pages[0].id ? 'is-active' : '' "
          >
            {{item.title}}
          </router-link>
        </li>
      </ul>
    </nav>
    <router-view></router-view>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import AdditionalPage from 'components/AdditionalPages/AdditionalPage'
import uuidv4 from 'uuid/v4'

export default {
  name: 'AdditionalPages',
  data () {
    return {
    }
  },
  computed: {
    ...mapState(['pages'])
  },
  created () {
    this.getPages(this.$route.params.id)
  },
  methods: {
    ...mapActions(['getPages', 'addNewPage', 'getPage']),
    handleAddPage () {
      this.addNewPage({
        id: uuidv4(),
        title: 'Дополнительная страница',
        text: '',
        isNew: true
      })
    }
  },
  components: { AdditionalPage }
}
</script>

<style scoped>
@import "../../global.css";
.additional-pages {
  display: flex;
}
nav{
  background: #eee;
}
.sub-menu,
.sub-menu ul {
  flex-direction: column;
}
.sub-menu {
  max-width: 280px;
  min-width: 280px;
}
.sub-menu ul li {
  width: 100%;
}
.button-wrapper {
  justify-content: center;
}
</style>



// WEBPACK FOOTER //
// Index.vue?90160e2a